// extracted by mini-css-extract-plugin
export default {"container":"JackpotLayerGameTile_container__Sgwtq"};